import React, { useState } from "react";
import Parallax2 from "../common/parallax/Parallax2";
import LeftAboutSection1 from "./section1/section1Left/LeftAboutSection1";
import RightAboutSection1 from "./section1/section1Right/RightAboutSection1";
import LeftAboutSection2 from "./section2/section2Left/LeftAboutSection2";
import RightAboutSection2 from "./section2/section2Right/RightAboutSection2";
import AboutSection1 from "./section1/AboutSection1";
import AboutSection2 from "./section2/AboutSection2";
import Modal from "../modal/Modal";
import ReviewAboutSection4 from "./section4/ReviewAboutSection4";
// import Parallax from '../common/parallax/Parallax'
// import AboutSection1 from './sections/section1/AboutSection1'

const About = () => {
  const [display, setDisplay] = useState(false);
  return (
    <div className="relative overflow-x-hidden ">
      <div className="z-10 ">
        <Parallax2 heading="ABOUT US" subHeading="HOME/ABOUT US" />
        <AboutSection1 />
        
        <div id="admission">
          <div className="bg-slate-100 pt-16 pb-10 mt-48">
            <h1 className="text-center text-3xl font-bold">
              EDUCATION IS{" "}
              <a className="text-gray-400 ">
                CULTIVATION , EXPANSION AND ENLIGHTENMENT
              </a>
            </h1>
            <h2
              onClick={() => {
                setDisplay(true);
              }}
              className="mx-24 mt-8 w-48 cursor-pointer bg-black py-4 text-center text-xl font-semibold text-white hover:bg-white hover:text-black lg:mx-auto "
            >
              Admission Open
            </h2>
          </div>
        </div>
        <AboutSection2 />
        <ReviewAboutSection4/>
      </div>
      <Modal display={display} setDisplay={setDisplay} />
    </div>
  );
};

export default About;
